import { h } from 'preact';

export default function Filter({
	label,
	name,
	onResetFilterHandler
}){

	function onClick() {
		onResetFilterHandler(name);
	}

	return (
		<div class="news-filter-active-filter-wrapper">
			<span>{label}<button onClick={onClick}>Verwijder {label} filter</button></span>
		</div>
	);
}
